import { RetryLink } from '@apollo/client/link/retry';

export const retryLink = new RetryLink({
  delay: {
    initial: 300,
    jitter: true,
    max: Infinity,
  },
  attempts: {
    max: 5,
    retryIf: error => !!error,
  },
});
